@if(isInitialized){
  @if (!isAskomaReadOnlyValue) {
    <oe-components-scheduler (schedule)="schedule" [(payload)]="payload">
      <ng-template let-task="task">
        {{ ("HEAT.SCHEDULE.MODE" | translate) + " " + task.payloadText }}
      </ng-template>
    </oe-components-scheduler>
  }
}
